// Material 3 Icon Component
// Aligned with Google Material Web (material-components/material-web/docs/components/icon.md)
(function () {
  // Brand logos (names "brand_<slug>", e.g. brand_linkedin): Material Symbols has none, so they are SVG paths from /shared/brand-icons.json
  // (tools/fetch-brand-icons.js), fetched once on first use and drawn in the current text colour.
  let brands = null, brandsLoading = null;
  const loadBrands = () => {
    if (!brandsLoading) brandsLoading = fetch('/shared/brand-icons.json').then(r => (r.ok ? r.json() : {})).then(d => { brands = d; return d; }).catch(() => { brands = {}; return brands; });
    return brandsLoading;
  };
  function BrandIcon({ name, size, color, style, ...props }) {
    const [, redraw] = React.useState(0);
    React.useEffect(() => { if (!brands) loadBrands().then(() => redraw(n => n + 1)); }, []);
    const b = brands && brands[name];
    return (
      <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" role={props['aria-label'] ? 'img' : undefined} aria-hidden={props['aria-label'] ? undefined : true}
        style={{ display: 'inline-block', flexShrink: 0, verticalAlign: 'middle', color: color || 'inherit', ...style }} {...props}>
        {b && <path d={b.d} />}
      </svg>
    );
  }

  function GoogleIcon({
    name,
    variant = 'outlined', // 'outlined' | 'rounded' | 'sharp' | 'classic'
    size = 24,
    filled = false,
    weight = 400,
    color,
    sx = {},
    className = '',
    style = {},
    ...props
  }) {
    if (!name) return null;
    // Decorative unless labelled: screen readers would otherwise read the ligature text ("edit_square")
    const a11y = props['aria-label'] ? { role: 'img' } : { 'aria-hidden': true };
    const trimmed = String(name).trim();

    if (/^brand_[a-z0-9]+$/.test(trimmed)) return <BrandIcon name={trimmed} size={size} color={color} style={style} {...props} />;

    // Check if string contains emojis or custom characters
    const isEmojiOrCustom = /[^\w-]/.test(trimmed);
    if (isEmojiOrCustom) {
      return (
        <span
          style={{
            fontSize: `${size}px`,
            lineHeight: 1,
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            verticalAlign: 'middle',
            userSelect: 'none',
            ...style
          }}
          {...a11y}
          {...props}
        >
          {trimmed}
        </span>
      );
    }

    // Convert PascalCase or camelCase to snake_case (e.g. SportsEsports -> sports_esports)
    const iconName = trimmed
      .replace(/([A-Z])/g, (match, p1, offset) => (offset > 0 ? '_' : '') + p1.toLowerCase())
      .trim();

    const baseClass = variant === 'rounded'
      ? 'material-symbols-rounded'
      : variant === 'classic'
        ? 'material-icons'
        : variant === 'sharp'
          ? 'material-symbols-sharp'
          : 'material-symbols-outlined';

    // FILL comes from --m3-icon-fill when a parent sets it (hover on chips / menu items, see m3.css), so the icon can animate to filled
    const fontVariationSettings = `'FILL' var(--m3-icon-fill, ${filled ? 1 : 0}), 'wght' ${weight}, 'GRAD' 0, 'opsz' ${Math.min(48, Math.max(20, size))}`;

    return (
      <span
        className={`${baseClass} ${className}`}
        style={{
          fontVariationSettings,
          fontSize: `${size}px`,
          width: `${size}px`,
          height: `${size}px`,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: 1,
          verticalAlign: 'middle',
          userSelect: 'none',
          color: color || 'inherit',
          transition: 'font-variation-settings var(--m3-duration-short) var(--m3-easing-standard)',
          ...style
        }}
        {...a11y}
        {...props}
      >
        {iconName}
      </span>
    );
  }

  // Alias MdIcon & GoogleIcon
  const Icon = GoogleIcon;

  window.Components = window.Components || {};
  window.Components.Icon = Icon;
  window.Components.GoogleIcon = GoogleIcon;
  window.Components.MdIcon = Icon;
})();
